"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const api_1 = require("@mne-core/api");
const URLBuilder_1 = require("./URLBuilder");
async function createLogMessageBulk(criteria, opts) {
    const { apiUrl, apikey, sessionKey, ctrl: optsCtrl, ...restOpts } = opts;
    const ctrl = optsCtrl || new api_1.QueryController();
    const uri = (0, URLBuilder_1.buildUrl)(apiUrl, ["client"]).toString();
    const headers = (0, api_1.createHeaders)({
        /* If the apikey is something else then undefined its added */
        "ARGUS-API-KEY": apikey,
        Accept: "application/json",
        "Argus-CSRF-Token": (0, api_1.createCsrfToken)(sessionKey, uri),
        "Content-Type": "application/json",
    });
    let localRequestOpts = {
        body: JSON.stringify(criteria, null, 2),
        headers,
        method: "POST",
        mode: "cors",
    };
    if (!apikey) {
        /**
         * Only add cookies if no apikey is provided
         */
        localRequestOpts = {
            ...localRequestOpts,
            credentials: "include",
        };
    }
    const query = await (0, api_1.fetchJsonQuery)(new Request(String(uri), {
        ...localRequestOpts,
        ...restOpts,
    }), { ctrl });
    return query;
}
exports.default = createLogMessageBulk;
